type UnauthorizedListener = () => void;

const listeners = new Set<UnauthorizedListener>();

/** Subscribe to "the server rejected our session". Used to pause the vault and ask for re-auth. */
export function onUnauthorized(listener: UnauthorizedListener): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

export function notifyUnauthorized(): void {
  for (const listener of listeners) {
    listener();
  }
}
